import {
  setHierarchyCode,
  setOrgCode,
  setOrgMappingData,
  setOrgToOrgMappingData,
  setOrganizationData,
  setOrganizationIdData,
  setParentId,
  setTreeData,
} from "../../../slices/org/organizationSlice";
import {
  RenderPage,
  openModal,
  resetFormState,
  updateRendererFormState,
} from "../../../slices/common/reducer";
import { showToast } from "../../../common/Toaster/Toaster";
import rootReducer from "../../../store";
import api from "../../../Utils/interface";

export const getOrganizationListing = (parentId) => {
  let fd = new FormData();

  fd.append("parentId", parentId);
  api
    .post(`/agsp/organization/getAllAccessibleOrganization`, fd)
    .then((res) => {
      rootReducer.dispatch(setOrganizationData(res.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export let createOrganization = async (entity, parentId, organizationtype) => {
  const updatedEntity = {
    ...entity,
    parentid: parentId,
    organizationtype: organizationtype,
  };
  //   let fd = new FormData();
  //   fd.append("entity", JSON.stringify(updatedEntity));

  await api
    .post(`/agsp/organization/createOrganization`, updatedEntity, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      rootReducer.dispatch(RenderPage());
      rootReducer.dispatch(resetFormState());
      rootReducer.dispatch(openModal(false));
      showToast("Organization added successfully", "success");
    })
    .catch((error) => {
      // const roleName = entity.name;
      showToast(error?.response?.data?.error_message, "error");
    });
};

export const getOrgRelationshipListing = (childOrgId, parentOrgId) => {
  let fd = new FormData();

  fd.append("childOrgId", childOrgId);
  fd.append("parentOrgId", parentOrgId);
  api
    .post(`/agsp/organization/getRelationshipDataWithHierarchy`, fd)
    .then((res) => {
      // console.log(res.data[].hierarchy_code)
      rootReducer.dispatch(setOrgMappingData(res.data));
      // rootReducer.dispatch(setHierarchyCode(res.data.hierarchy_code));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getOrganizationData = (organizationId) => {
  let fd = new FormData();

  fd.append("organizationId", organizationId);
  api
    .post(
      `/agsp/organization/getOrganizationDataById`,
      fd
    )
    .then((res) => {
      rootReducer.dispatch(setOrganizationIdData(res.data));
      rootReducer.dispatch(updateRendererFormState(res.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getDropdownHierarchyByCode = (hierCode) => {
  let fd = new FormData();

  fd.append("hierCode", hierCode);
  api
    .post(`/agsp/organization/getDropdownHierarchyByCode`, fd)
    .then((res) => {
      // console.log(res.data);
      rootReducer.dispatch(setTreeData(res.data));
      rootReducer.dispatch(setHierarchyCode(res.data.hierarchy_node.code));
      rootReducer.dispatch(setOrgCode(res.data.hierarchy_node.organization_id));
      rootReducer.dispatch(setParentId(res.data.hierarchy_node.id));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const createOrgToOrgMapping = (parentId, childId, hierarchyCode) => {
  let fd = new FormData();

  fd.append("parentId", parentId);
  // console.log("===>", parentId);
  fd.append("childId", childId);
  fd.append("hierarchyCode", hierarchyCode);

  api
    .post(`/agsp/organization/createOrgToOrgMapping`, fd)
    .then((res) => {
      // console.log(res.data);
      rootReducer.dispatch(setOrgToOrgMappingData(res.data));
    })
    .catch((err) => {
      console.log(err);
      showToast(err.response?.data?.error_message, "error");
    });
};

export let updateOrganization = async (entity, navigator) => {
  let fd = new FormData();

  // Object.keys(entity).forEach((key) => {
  //   fd.append(key, entity[key]);
  // });
  const data = JSON.parse(
    JSON.stringify(entity, (key, value) => (value === "null" ? null : value))
  );

  try {
    const response = await api.post(
      `/agsp/organization/updateOrganization`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    navigator("/org/org");
    showToast("Organization Updated Successfully!", "success");
  } catch (error) {
    showToast(error?.response?.data?.error_message, "error");
  }
};

export const updateHierarchy = (parentId, childId) => {
  let fd = new FormData();

  fd.append("parentId", parentId);
  // console.log("===>", parentId);
  fd.append("childId", childId);

  api
    .post(`/agsp/organization/updateHierarchy`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      // console.log(res.data);
      // rootReducer.dispatch(setOrgToOrgMappingData(res.data));
    })
    .catch((err) => {
      console.log(err);
    });
};
